import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";

import AutoCompleteDropdown from "../../../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../../Base/Services/ToastService";

import { getEstadosCategory } from "../../../../../API/Global/Status/StatusRequests";

import { obtenerCategoriasAct } from "../../../../../Base/API/Global/Categorias/CategoriasRequests";
import { modificarSubCategoria, obtenerSubCategoriasAct } from "../../../../../Base/API/Global/SubCategorias/SubCategoriasRequests";
import Loader from "../../../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext"; 
import { Checkbox } from "primereact/checkbox";

const SubCategoriasCrudModal = ({
  subcategoria,
  subcategoriasDialog,
  setSubcategoriasDialog,
  toastRef,
  getSubCat,
  modo,
}) => {
  const toast = useRef(null);

  const [show, setShow] = useState(false);
  const [categoriasList, setCategoriasList] = useState([{}]);
  const [subcategoriasList, setSubCategoriasList] = useState([{}]);
  const [estados, setEstados] = useState([{}]);
  const [loading, setLoading] = useState(false);
  const { userAuth } = useContext(AuthContext);

  const initialValues = {
    IdSubCategoria: -1,
    NombreSubcategoria: "",
    IdCategoria: "",
    IdStatus: subcategoria ? subcategoria?.IdStatus : 5,
    Comentario: "",
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } =
    useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true)
    const categoriaAct = await obtenerCategoriasAct();
    const estadosTempo = await getEstadosCategory("General");
    const subC = await obtenerSubCategoriasAct();

    setCategoriasList(categoriaAct);
    setSubCategoriasList(subC);
    setEstados(estadosTempo);

    // Si el modo es "Crear", establece el primer estado como valor inicial
    const estadoInicial =
      modo === "Crear"
        ? estadosTempo[0]
        : estadosTempo.find((e) => e.IdStatus === subcategoria?.IdStatus);

    setValues({
      ...subcategoria,
      Estado: estadoInicial,
      IdStatus: estadoInicial.IdStatus,
      Categorias: categoriaAct.find((c) => subcategoria?.IdCategoria === c.IdCategoria),
    });
    setLoading(false)
  };

  const onHide = () => {
    setSubcategoriasDialog(false);
    resetForm();
    setShow(false);
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.NombreSubcategoria) {
      error.NombreSubcategoria = true;
      error.error = true;
    }
    if (!values.Categorias || !values.Categorias?.IdCategoria) {
      error.IdCategoria = true;
      error.error = true;
    }
    if (!values.Estado || !values.Estado.IdStatus) {
      error.IdStatus = true;
      error.error = true;
    }
    if (!/^[A-Za-z0-9ÁÉÍÓÚáéíóúÑñ\s.\-_]*$/.test(values.Comentario)) {
      error.Comentario = true;
      error.error = true;
    }
    setError(error);
    return error;
  };

  
  const subCatExistsWithSameName = () => {
    const sameNameEstantes = subcategoriasList.filter(
      (item) =>
        item.NombreSubcategoria.toLowerCase() === values.NombreSubcategoria.toLowerCase() &&
        item.IdCategoria === values.Categorias.IdCategoria &&
        item.IdSubCategoria !== values.IdSubCategoria
    );
    return sameNameEstantes.length > 0;
  };

  const agregarSubcategoria = async () => {
    const e = verificarInfo();

    if (!e.error) {

      if (subCatExistsWithSameName()) {
        toastShow(toast, "error", "Error", "Ya existe una categoría con el mismo nombre en este tipo de producto.");
        return;
      }


      let estadoId = null;
      if (values.Estado) {
        estadoId = values.Estado.IdStatus;
      }
      const a = {
        IdSubCategoria: values?.IdSubCategoria,
        NombreSubcategoria: values?.NombreSubcategoria,
        IdCategoria: values.Categorias.IdCategoria,
        IdStatus: estadoId,
        Comentario: values?.Comentario,
        IdUserCreate: userAuth?.IdUser,
        AplicaLiquidacion: values?.AplicaLiquidacion,
      };
      const resultado = await modificarSubCategoria(a);
      if (modo === "Crear") {
        onHide();
        toastShow(toastRef, "success", "Datos Agregados","Categoría Agregada exitosamente.");
        getSubCat();
      } else {
        onHide();
        toastShow(toastRef, "success", "Datos Agregados","Categoría modificada exitosamente.");
        getSubCat();
      }
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Modificar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          if (modo === "Crear") {
            agregarSubcategoria();
          } else {
            agregarSubcategoria();
          }
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (subcategoriasDialog) {
      getValoresIniciales();
    }
  }, [subcategoriasDialog]);

  const dialogTitle =
    modo === "Crear" ? "Agregar SubCategoría " : "Modificar SubCategoría ";

  return (
    <div>
      <ConfirmDialog />
      <Dialog
        visible={subcategoriasDialog}
        modal
        className="modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
      <Toast ref={toast}/>
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />

          <div style={{ width: "100", margin: "auto" }}>
            <div className="d-flex align-items-center">
              <h2 className="me-3">{dialogTitle}</h2>
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2">
              <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Categorias"}
                    value={values.Categorias}
                    items={categoriasList}
                    field={"NombreCategoria"}
                    label={"Categoría"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdCategoria ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-6 me-2">
              <span className="p-float-label">
                  <InputText
                    name="NombreSubcategoria"
                    value={values.NombreSubcategoria}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.NombreSubcategoria ? "p-invalid" : ""}
                  />
                  <label htmlFor="NombreSubcategoria">
                    Nombre de SubCategoría
                  </label>
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2">
                <span className="p-float-label">
                  <InputText
                    name="Comentario"
                    value={values.Comentario}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.Comentario ? "p-invalid" : ""}
                  />
                  <label htmlFor="Comentario">Comentario</label>
                  {error.Comentario && (
                    <small className="p-error">
                      El Comentario solo puede contener letras, números,
                      espacios y los caracteres '.', '_', '-'.
                    </small>
                  )}
                </span>
              </div>

              <div className="field col-6 me-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Estado"}
                    value={values.Estado}
                    items={estados}
                    field={"StatusName"}
                    label={"Estado"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdStatus ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor mt-3">
              <div className="field col-6">
                  <span className="p-float-label">
                    <Checkbox
                      checked={values?.AplicaLiquidacion}
                      onChange={(e) =>
                        setValues({
                          ...values,
                          AplicaLiquidacion: e.target.checked,
                        })
                      }
                    />
                    <label htmlFor="AplicaLiquidacion">
                      &nbsp;&nbsp;&nbsp;&nbsp;Aplica a Liquidacion
                    </label>
                  </span>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default SubCategoriasCrudModal;
